import { render, staticRenderFns } from "./WalletPaymentReport.vue?vue&type=template&id=7cd84c94&"
import script from "./WalletPaymentReport.vue?vue&type=script&lang=js&"
export * from "./WalletPaymentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports